<app-label-dev *ngIf="!isProduction"></app-label-dev>
<app-loading></app-loading>

<router-outlet></router-outlet>

<app-backdrop></app-backdrop>
<!-- <div id="orientation-landscape" class="hide">Vire seu dispositivo</div> -->
<!-- <div style="margin: 0 auto;width: 100%;text-align: right;color:#c8d6e5;position: fixed;bottom: 0px;" class="d-print-none">Version {{version}}</div> -->
